import React from "react";
import MultipleOfficesLP from "../MultipleOfficesLP";

function HalsNasenOhrenHeilkundeLP() {
  var officeArray = [
    {
      doctorName: "dr. med. Haji Ahmadian",
      doctorTitle: "Facharzt für Hals-Nasen-Ohrenheilkunde",
      officeLoc: "Falkenberg/Elster",
      navLink: "/hals-nasen-ohrenheilkunde-ahmadian",
    },
    {
      doctorName: "Luei Charanek",
      doctorTitle: "Facharzt für Hals-Nasen-Ohrenheilkunde",
      officeLoc: "Falkenberg/Elster",
      navLink: "/hals-nasen-ohrenheilkunde-charanek",
    },
  ];

  return (
    <MultipleOfficesLP
      officeType={"Hals-Nasen-Ohrenheilkunde"}
      officeArray={officeArray}
    />
  );
}

export default HalsNasenOhrenHeilkundeLP;
